import ChModel from "./Ch";

export const typeSingle = "Single";
export const typeMulti = "Multi";
export const typeChild = "Child";
export const typeTimeline = "Timeline";
export const typeTimelineStock = "TimelineStock";
export type PostType =
  | typeof typeSingle
  | typeof typeMulti
  | typeof typeChild
  | typeof typeTimeline
  | typeof typeTimelineStock;

export type Post = {
  uid: string;
  connection: string;
  content: string;
  stampId: number;
//  title: string;
  favicon: string;
  type: PostType;
  currentTime: string;
  createTime: string
  updateTime: string;
  userName?: string;
  userAvatar?: string;
  replyToId?: string;
};

export const init: Post = {
  uid: "",
  connection: "",
  content: "",
  stampId: 0,
  favicon: "",
  type: typeSingle,
  createTime: String(new Date()),
  updateTime: String(new Date()),
  currentTime: ""
};

export default class PostModel implements Post {
  uid = "";
  connection = "";
  content = "";
  stampId = 0;
//  title = "";
  favicon = ""; // TODO url
  type: PostType = typeSingle;
  createTime = String(new Date());
  updateTime = String(new Date());
  currentTime = "";
  userName?: string;
  userAvatar?: string;
  replyToId?: string;
  constructor(params: Partial<Post> = {}) {
    Object.assign(this, { ...init, ...params });
  }
}
